import { Store } from 'repatch';

import State from '../core/State';
import { disposeFatalError, setFatalError } from '../thunk/fatalError';
import { addNonFatalError, removeNonFatalError } from '../thunk/nonFatalErrors';
import ErrorReporter from './ErrorReporter';

class ErrorPresenter {
  private store: Store<State>;
  private errorReporter: ErrorReporter;

  constructor({ store, errorReporter }: { store: Store<State>; errorReporter: ErrorReporter }) {
    this.store = store;
    this.errorReporter = errorReporter;
  }

  public reportError = (err: Error): void => {
    this.errorReporter.reportError(err);
  };

  public showAsNonFatal = (err: Error): void => {
    this.errorReporter.reportError(err);
    this.store.dispatch(addNonFatalError(err));
  };

  public showAsFatal = (err: Error, solveTo = '/'): void => {
    if (this.store.getState().fatalError) {
      console.error('ErrorPresenter#showAsFatal() has called in fatal error has been occuring.');
    }

    this.errorReporter.reportError(err);

    this.store.dispatch(setFatalError(err, solveTo));
  };

  public removeNonFatal = (err: Error): void => {
    this.store.dispatch(removeNonFatalError(err));
  };

  public resolveFatal = (): void => {
    this.store.dispatch(disposeFatalError());
  };
}

export default ErrorPresenter;
